export default {
  mounted() {
    const MAX_ATTEMPTS = 30;
    const RETRY_DELAY = 500;

    const tryRefresh = (attempt = 0) => {
      try {
        const y = window.yotpo;
        const yc = window.yotpoWidgetsContainer;

        if (yc && typeof yc.initWidgets === "function") {
          yc.initWidgets();
          return;
        }

        if (y && typeof y.initWidgets === "function") {
          y.initWidgets();
          return;
        }

        if (
          y &&
          (typeof y.refreshWidgets === "function" || y.API?.refreshWidgets)
        ) {
          if (typeof y.refreshWidgets === "function") {
            y.refreshWidgets();
          } else if (typeof y.API?.refreshWidgets === "function") {
            y.API.refreshWidgets();
          }
          return;
        }

        if (typeof window.yotpoLoader?.load === "function") {
          window.yotpoLoader.load();
          return;
        }

        if (attempt < MAX_ATTEMPTS) {
          setTimeout(() => tryRefresh(attempt + 1), RETRY_DELAY);
        }
      } catch (err) {
        console.error(err);
        if (attempt < MAX_ATTEMPTS) {
          setTimeout(() => tryRefresh(attempt + 1), RETRY_DELAY);
        }
      }
    };

    tryRefresh();
  },
};
